<template>
  <div class="column full-width no-wrap">
    <CommandsList
      :open="open"

      :options="suggestions"
      v-model="indexSuggestion"

      @on-close="onCloseSuggestion"
      @on-click="onSelectSuggestion"
    />

    <div class="col-auto row items-center full-height content-center input-target-chat">
      <div
        class="col full-width justify-end"
        style="position: relative"
      >
        <input
          data-testid="transferencia-mensagem"
          ref="message"
          class="col full-width input-message"
          style="line-height: 27px"
          placeholder="Deseja Transferir?"
          v-model="message"
          @keydown.enter.prevent="handleMessage"
          @keydown.esc.prevent="onCloseSuggestion"
          @keydown.up.exact.prevent="updateActiveUpOrDown(-1)"
          @keydown.down.exact.prevent="updateActiveUpOrDown(1)"
        >
      </div>
      <div class="col-auto">
        <q-btn
          data-testid="transferencia-enviar"
          flat
          no-caps
          padding="7px 4px"
          class="col-auto q-mx-xs"
          @click="handleMessage"
        >
          <SendIcon class="send-icon" />
          <q-tooltip>Enviar</q-tooltip>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import SendIcon from '@/assets/icons/send-message.svg'
import CommandsList from './CommandsList.vue'

export default {
  components: {
    SendIcon,
    CommandsList
  },

  data () {
    return {
      open: false,
      message: '',
      invalidChar: 'Você precisa digitar um código válido de Agente!',

      indexSuggestion: 0,
      rootSuggestions: { options: [], selected: -1 }
    }
  },

  computed: {
    suggestions () {
      const suggestions = getNextSuggestions(this.rootSuggestions).options
      return suggestions.filter(byLabel(this.message))
    },

    isCommand () {
      const vm = this
      const commands = vm.suggestions.filter((item) => item.label[0] === '/' && !item.options?.length).map((item) => toLower(item.label))
      return Boolean(commands.find((command) => toLower(vm.message).startsWith(command)))
    }
  },

  methods: {
    handleMessage () {
      const vm = this

      if (!vm.message) return

      if (vm.open) {
        vm.onSelectSuggestion(this.indexSuggestion)
        return
      }

      if (vm.message[0] !== '/') {
        vm.$nextTick().then(() => {
          vm.message = ''
        })
        return
      }

      const destination = Number(vm.message.split(' ').pop())
      if (!destination) return newNotification('ERRO', vm.invalidChar)

      vm.$emit('on-command', { destination })

      vm.$nextTick().then(() => {
        vm.message = ''
      })
    },

    onCloseSuggestion () {
      if (this.open) this.open = false
    },

    updateActiveUpOrDown (direction) {
      const vm = this
      if (!vm.open) return
      if (!vm.suggestions.length) return

      const maxIndex = vm.suggestions.length - 1
      let indexSuggestion = vm.indexSuggestion + direction
      if (indexSuggestion < 0) indexSuggestion = maxIndex
      if (indexSuggestion > maxIndex) indexSuggestion = 0
      if (indexSuggestion === vm.indexSuggestion) return

      vm.indexSuggestion = indexSuggestion
    },

    setNextSuggestions (selected) {
      const vm = this
      const rootSuggestions = JSON.parse(JSON.stringify(vm.rootSuggestions))
      getNextSuggestions(rootSuggestions).selected = selected

      const message = '/'
      const indexSuggestion = 0
      Object.assign(vm, { message, indexSuggestion, rootSuggestions })
    },

    clearSuggestions () {
      const vm = this
      const indexSuggestion = 0
      const rootSuggestions = clearSuggestions(JSON.parse(JSON.stringify(vm.rootSuggestions)))
      Object.assign(vm, { indexSuggestion, rootSuggestions })
    },

    onSelectSuggestion (indexSuggestion) {
      const vm = this
      if (!vm.open) return
      if (!vm.suggestions.length) return
      if (indexSuggestion < 0) return
      if (indexSuggestion > vm.suggestions.length - 1) return

      const option = vm.suggestions.at(indexSuggestion)
      const hasSubOptions = Boolean(option.options?.length)
      if (hasSubOptions) return vm.setNextSuggestions(indexSuggestion)

      const message = String(vm.message).trim()
      const hasParams = message.split(' ').length > 1

      if (hasParams) {
        vm.open = false
        return vm.$nextTick().then(vm.handleMessage)
      }

      vm.message = option.label
    }
  },

  watch: {
    message: {
      deep: true,
      handler (message, oldMsg) {
        const vm = this
        const msg = toLower(message)
        if (msg === toLower(oldMsg)) return

        if (msg[0] === '/' && !vm.open) {
          vm.rootSuggestions.options = defaultSuggestions()
          vm.open = true
        }

        if (msg[0] !== '/' && vm.open) vm.open = false
        if (!msg) vm.clearSuggestions()
      }
    },

    suggestions: {
      deep: true,
      handler (newSuggestions, oldSuggestions) {
        const vm = this
        if (!vm.open) return
        if (isEqual(newSuggestions, oldSuggestions)) return
        vm.open = false
        vm.$nextTick().then(() => {
          vm.open = true
        })
      }
    }
  }
}

const defaultSuggestions = () => (
  [{
    id: 'transferir',
    label: '/transferir ',
    option: 'matricula',
    class: 'option-command',
    description: 'Transfira para o Código do Agente'
  }]
)

const getNextSuggestions = (suggestions) => {
  if (suggestions.selected === -1) return suggestions
  return getNextSuggestions(suggestions.options[suggestions.selected])
}

const clearSuggestions = (suggestions) => {
  if (suggestions.options) {
    suggestions.selected = -1
    suggestions.options.forEach(clearSuggestions)
  }

  return suggestions
}

const newNotification = (title, body) => (
  new Notification(title, { body })
)

const byLabel = (msg) => {
  const arg = clearArg(msg)

  return (item) => {
    const label = clearArg(item.label)
    if (label.includes(arg)) return true

    for (const word of arg.split(' ')) {
      if (label.includes(word.trim())) return true
    }

    return false
  }
}

const isEqual = (source, target) => (
  JSON.stringify(source) === JSON.stringify(target)
)

const clearArg = (val) => (
  toLower(val[0] === '/' ? val.split('').splice(1, val.length).join('') : val)
)

const toLower = (val) => (
  String(val || '').toLowerCase().trim()
)

</script>

<style lang="sass" scoped>
.send-icon
  width: 21px
  height: 21px
  right: 0
  transform: matrix(0.95, 0.34, -0.31, 0.94, 0, 0)
  filter: invert(22%) sepia(98%) saturate(1291%) hue-rotate(188deg) brightness(65%) contrast(97%)

.input-message
  border: 1px solid #CDDCE5
  padding: 2px 8px
  color: #01253C
  font-weight: normal
  font-size: 13px
  line-height: 15px
  border-radius: 2px
  &:focus
    border: 1px solid #1769B6
    outline: none
  &:hover
    border: 1px solid #1769B6
  &::-webkit-input-placeholder
    color: #01253C
    opacity: 0.5

.count-input
  font-size: 9px
  color: #626161
</style>
